import React from 'react';

import './Testimonials.scss';

const testimonials = [
  {
    name: 'Tom',
    location: 'Brooklyn, NY',
    quote: 'My mailbox has been extremely peaceful. 10/10, would do again.',
  },
  {
    name: 'Owen',
    location: 'Sunnyvale, CA',
    quote: "I've sent over 15 opt-out requests and haven't seen any junk mail come back.",
  },
  {
    name: 'Anna',
    location: 'Houston, TX',
    quote: 'Very pleased with the results — and how quickly the mail stopped coming.',
  },
  {
    name: 'Lavinia',
    location: 'Dorchester, MA',
    quote: 'My junk mail has disappeared to a great extent. Recommend everyone try it.',
  },
  {
    name: 'Muhammad',
    location: 'Louisville, KY',
    quote: 'Doing a great job reducing junk mail and saving the environment at the same time.',
  },
  {
    name: 'Vicki',
    location: 'Middletown, OH',
    quote: 'Simplified my life and helping save the environment.',
  },
];

const initialsFor = (name) => name.trim().charAt(0).toUpperCase();

const TestimonialCard = ({ name, location, quote }) => (
  <figure className="TestimonialCard">
    <div className="TestimonialCard__header">
      <div className="TestimonialCard__avatar" aria-hidden="true">{initialsFor(name)}</div>
      <figcaption className="TestimonialCard__who">
        <span className="TestimonialCard__name">{name}</span>
        <span className="TestimonialCard__location">{location}</span>
      </figcaption>
    </div>
    <div className="TestimonialCard__stars" aria-label="5 out of 5 stars">★★★★★</div>
    <blockquote className="TestimonialCard__quote">{quote}</blockquote>
  </figure>
);

const Testimonials = () => (
  <section id="testimonial" className="TestimonialsStrip">
    <div className="TestimonialsStrip__header">
      <h2>Real customers. Real empty mailboxes.</h2>
      <p>From people who used Wabi to take back their mailbox.</p>
    </div>

    <div className="TestimonialsStrip__grid">
      {testimonials.map((t) => (
        <TestimonialCard key={t.name} {...t} />
      ))}
    </div>
  </section>
);

export default Testimonials;
